module.exports = __webpack_public_path__ + "static/media/TelaSaqueReaporteEN.e9d08036.png";